import { QueryFunctionContext, useInfiniteQuery } from "@tanstack/react-query";

import { useInventoryApi } from "../../hooks";
import { API_LIMIT } from "../../utils/constants";
import { InventoryApiListAccessUnitsRequest } from "../../api/v1";

const QUERY_KEY = "listAccessUnits";
export default function useListAccessUnits({
  limit = API_LIMIT,
  skip = 0,
  ...props
}: InventoryApiListAccessUnitsRequest) {
  const api = useInventoryApi();

  const fetchAccessUnits = async ({
    pageParam = skip,
  }: QueryFunctionContext) => {
    return await api.listAccessUnits({
      ...props,
      limit,
      skip: pageParam,
    });
  };

  return useInfiniteQuery({
    queryKey: [QUERY_KEY, props],
    queryFn: fetchAccessUnits,
    getNextPageParam: (lastPage) => {
      return lastPage.pagination.has_more
        ? lastPage.pagination.offset + lastPage.pagination.limit
        : undefined;
    },
    keepPreviousData: true,
  });
}
